import { FormPage } from '@checkit/react-components';
import { EditIcon } from '@checkit/react-components/build/components/Icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';

import { messages as msg } from '../../checkpointTypes/new/NewCheckpointType.translations';
import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import { isUpdateCheckpointTypeSuccess, updateCheckpointType } from '../actions';
import CheckpointTypeForm from '../form/CheckpointTypeForm';
import { CheckpointTypeData } from '../state';

import { messages } from './UpdateCheckpointType.translations';

export const UpdateCheckpointType: React.FC<RouteComponentProps<{ checkpointTypeCode: string }>> = ({
  match,
  history
}) => {
  const {formatMessage} = useIntl();
  const dispatch = useAxiosDispatch( );

  const typeCode = match.params.checkpointTypeCode;

  const onSubmit = async (data: CheckpointTypeData): Promise<AnyAction> => {
    const action = await dispatch(updateCheckpointType(typeCode, data, history));

    if (isUpdateCheckpointTypeSuccess(action)) {
      dispatch(createSnackbar({
        message: formatMessage(messages['checkpointType.update.success']),
        options: {
          variant: 'success'
        }
      }));
    } else {
      const errorType = action.error ? (action as any).error.response.data.message : null;
      if (errorType === msg.CHECKPOINT_TYPE_NAME_NOT_UNIQUE.id) {
        dispatch(createSnackbar({
          message: formatMessage(msg.CHECKPOINT_TYPE_NAME_NOT_UNIQUE),
          options: {
            autoHideDuration: 6000,
            variant: 'error'
          }
        }));
      } else {
        dispatch(createSnackbar({
          message: formatMessage(messages['checkpointType.update.error']),
          options: {
            variant: 'error'
          }
        }));
      }
    }

    return action;
  };

  return (
    <FormPage
      pageTitle={formatMessage(messages['checkpointType.update.pageTitle'])}
      pageIcon={<EditIcon />}
    >
      <CheckpointTypeForm code={typeCode} onSubmit={onSubmit} />
    </FormPage>
  );
};
